<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.account.termsOfUse.title")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12"
        v-if="$i18n.locale === 'ja'">
<p align="left">
  公益社団法人日本プロサッカーリーグ及び株式会社Ｊリーグ（以下「Ｊリーグ」と総称します。）が運営するメディアサービス（以下「本サービス」と称します。）のコンテンツは、次に定める条件（以下「利用規約」と称します。）にしたがってご利用いただくことを条件として、Ｊリーグが提供するものです。
</p>
<p align="left">
  ※本サービスに含まれるWEBサイト
  <br/>
  ・メディアポータル（認証基盤）
  <br/>
  ・メディアチャンネル
  <br/>
  ・映像利用申請システム
  <br/>
  ・プロダクションポータル
</p>
<p align="left">
  サイト利用者が本サービスにアクセスしてこれを利用した場合は、この利用規約に同意したものとみなします。
</p>
<p align="left">
  なお、各サイトにて別途定める規約がある場合はそれを優先します。
</p>
<p align="left">
  利用者には、本サービスを合法的な目的にのみ利用することに同意していただきます。また以下の事項に該当する場合には、Ｊリーグは利用者に対して除名・法的措置をとらせていただくことがあります。
</p>
<p align="left">
  ・Ｊリーグが定める著作権規定に対して違反する行為また他者の著作権、商標権等の知的財産権を侵害する行為、またはそのおそれのある行為があった場合
  <br/>
  ・他者の財産、プライバシーもしくは肖像権を侵害する行為、またはそのおそれのある行為があった場合
  <br/>
  ・他者を差別もしくは誹謗中傷し、または他者の名誉もしくは信用を毀損する行為があった場合
  <br/>
  ・本サービスの運営を妨害する行為があった場合
  <br/>
  ・別の他人や組織などになりすましたり、人物、企業、グループあるいはその他の実体との関係を故意に詐称したりした場合
  <br/>
  ・意図的に法律違反をした場合
  <br/>
  ・上記各項目のいずれかに該当する行為（当該行為を他者が行っている場合を含む）を助長する目的の行為（リンクを張る等を含む）があった場合
</p>
<p align="left">
  本利用規約は予告なしに変更される場合があります。本利用規約を変更した後、サイト利用者が本サービスを利用・閲覧した時点で変更後の利用規約に同意したものとみなします。
</p>
<p align="left">
  <strong>[ 1. </strong>
  <strong>本サービスの利用について ]</strong>
  <strong></strong>
</p>
<p align="left">
  本サービスをご利用になる場合には、ウェブにアクセスしていただく必要があります。利用者には、自らの責任と費用で必要な機器やソフトウェア、通信手段等をご用意いただき、それらを適切に設置、操作いただく必要があります。Ｊリーグは利用者がウェブにアクセスされるための準備、方法などについては一切関与いたしません。
</p>
<p align="left">
  <strong>[ 2. </strong>
  <strong>利用者登録について ]</strong>
  <strong></strong>
</p>
<p align="left">
  本サービスをご利用頂くにあたっては、ユーザー登録のための書式に利用者ご自身に関する真実かつ正確なデータを入力してご申請ください。
</p>
<p align="left">
  万一上記に違反した場合または真実かつ正確なデータが提供されていないとＪリーグが判断した場合には、Ｊリーグは当該利用者のIDを削除し、将来に渡ってサービスを利用することをお断りする権利を有しております。
</p>
<p align="left">
  <strong>[ 3. ID</strong>
  <strong>ならびにパスワードの管理 ]</strong>
  <strong></strong>
</p>
<p align="left">
  IDならびにパスワードの管理は利用者の責任において行っていただきます。IDならびにパスワードを利用して行われた行為の責任は当該IDを保有している利用者の責任とみなします。
</p>
<p align="left">
  万一、許可なく自分のIDが利用された場合、またはIDならびにパスワードが第三者に漏洩してしまった場合にはただちにパスワードの再発行を行うかJリーグまでご連絡ください。
</p>
<p align="left">
  <strong>[ 4. </strong>
  <strong>有効期限 ]</strong>
  <strong></strong>
</p>
<p align="left">
  IDならびにパスワードは、本サービスのアカウント情報の登録解除をするまでご利用いただけます。
</p>
<p align="left">
  ただし、登録者のサービス利用が長期間にわたってＪリーグで取れない場合、以後のご利用を停止させていただく場合がありますので、予めご了承下さい。
</p>
<p align="left">
  <strong>[ 5. </strong>
  <strong>申し込み内容の変更について ]</strong>
  <strong></strong>
</p>
<p align="left">
  利用者は、登録した情報について変更があったときは、利用方法に従い遅滞なく利用者情報の変更を行うものとします。
</p>
<p align="left">
  <strong>[ 6. </strong>
  <strong>免責事項について ]</strong>
  <strong></strong>
</p>
<p align="left">
  Ｊリーグは本サービスへの掲載内容に関して、細心の注意を払って運営しております。しかしながら、それらの情報の正確性・有効性・安全性等に関しまして一切の保障をするものではなく、また利用者が本サービスおよび本サービスの情報を利用することによって生じる、いかなる損害についても責任を負うものではありません。
</p>
<p align="left">
  また、本サービスの掲載内容に関する無断使用・複製をすることを一切禁止いたします。
</p>
<p align="left">
  <strong>[ 7. </strong>
  <strong>個人情報の取り扱いについて ]</strong>
  <strong></strong>
</p>
<p align="left">
  本サービスでご登録いただいた個人情報は、Ｊリーグが別途定める「プライバシーポリシー」に基づく適切な管理の下、本サービスにおけるシステム上または業務上のサービス提供のために利用されます。
</p>
<p align="left">
  登録者様ご本⼈の同意がある場合を除き、それ以外の目的で個⼈情報を第三者に開示することはありません。
</p>
<p align="left">
  また、Ｊリーグにおいて、個人が識別できない形でデータ活用させていただく場合があります。
</p>
<p align="left">
  <strong>[ 8. </strong>
  <strong>著作権について ]</strong>
  <strong></strong>
</p>
<p align="left">
  本サービス上の文書・画像・映像等コンテンツの著作権は、Ｊリーグおよびその関連団体に帰属します。本サービス利用者は、各著作権所有組織の了解・許諾があった場合を除き、営利・非営利の目的にかかわらず本サービス上の文書・画像・映像等コンテンツを複製することはできません。
</p>
<p align="left">
  また本サービス上のコンテンツは著作権法により保護されています。サイト利用者が著作権者の権利を侵害した場合には、著作権法により罰せられますのでご注意ください。
</p>
<p align="left">
  <strong>[ 9. </strong>
  <strong>本サービスへのリンク ]</strong>
  <strong></strong>
</p>
<p align="left">
  本サービスにリンクを張る場合には、必ずＪリーグまでご連絡ください。その際、本サービスの内容上、リンクを張ることをお断りすることもありますので、予めご了承ください。
</p>
<p align="left">
  <strong>[ 10. </strong>
  <strong>本サービスの運営に関して ]</strong>
  <strong></strong>
</p>
<p align="left">
  Ｊリーグは、予告なしに本サービス上の情報を変更あるいは削除、本サービスの運用を中断または中止することがあります。また、以下のいずれかの事由が生じた場合には、利用者に事前に通知することなく、一時的に本サービスを中断することができるものとします。
</p>
<p align="left">
  ・本サービスのメンテナンスを定期的にもしくは緊急に行う場合
  <br/>
  ・火災、停電等により本サービスの提供ができなくなった場合
  <br/>
  ・地震、噴火、洪水、津波等の天災によりの提供ができなくなった場合
  <br/>
  ・戦争、変乱、暴動、騒乱、労働争議等により本サービスの提供ができなくなった場合
  <br/>
  ・システムに負荷が集中した場合、又はセキュリティ上の問題があるとＪリーグが判断した場合
  <br/>
  ・その他、運用上または技術上、Ｊリーグが本サービスの一時的な中断が必要と判断した場合
</p>
<p align="left">
  Ｊリーグは、前項各号のいずれか、またはその他の事由により本サービスの提供の遅延または中断等が発生したとしても、これに起因する利用者または他者が被った被害について一切責任を負わないものとします。
</p>
<p align="left">
  <strong>[ 11.</strong>
  <strong>準拠法・裁判管轄 ]</strong>
  <strong></strong>
</p>
<p align="left">
  この利用規約の解釈にあたっては、日本法が適用されるものとします。
</p>
<p>
  本サービスに関連して、利用者とＪリーグとの間で紛争が生じた場合には、当事者間において誠意をもって協議のうえ、解決するものとします。協議によって解決しない紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
</p>
<hr />

      </v-col>
      <v-col cols="12"
        v-if="$i18n.locale === 'en'">
<p align="left">
    The contents of the media service (hereinafter referred to as "The
    Service") are managed by JAPAN PROFESSIONAL FOOTBALL LEAGUE and J.LEAGUE
    INC. (hereinafter collectively referred to as "J.LEAGUE"). The Service is
    provided by the J.LEAGUE on condition that you use in accordance with the
    following terms and conditions (hereinafter referred to as "Terms of Use").
</p>
<p align="left">
    *Websites included in The Service
    <br/>
    - MEDIA PORTAL (Authentication Platform)
    <br/>
    - MEDIA CHANNEL
    <br/>
    - VIDEO USAGE APPLICATION SYSTEM
</p>
<p align="left">
    - PRODUCTION PORTAL
</p>
<p align="left">
    If you access and use The Service, you agree to abide by these Terms of
    Use.
</p>
<p align="left">
    If there are separate terms and conditions applicable to the websites,
    those terms and conditions shall take precedence.
</p>
<p align="left">
    You agree to use The Service for lawful purposes only. The J.LEAGUE
    reserves the right to expel or take legal action against a user if any of
    the following conditions apply.
</p>
<p align="left">
    - Any act that violates the J.LEAGUE's copyright regulations or
    infringement of copyrights, trademarks or other intellectual property
    rights of others, or any act alike.
</p>
<p align="left">
    - When there is any act of infringement of property, privacy or portrait
    rights of others, or there is a risk of such an act.
</p>
<p align="left">
    - When there is any discrimination against or slander another person, or
    damage the honor or credibility of another person.
</p>
<p align="left">
    - When there is any act that interferes with the operation of The Service.
</p>
<p align="left">
    - If there is any act of impersonating another person, organization, etc.,
    or knowingly misrepresent your relationship with a person, company, group,
    or other entity.
</p>
<p align="left">
    - Intentionally violating the law.
</p>
<p align="left">
    - If there is any act (including uploading a link, etc.) for the purpose of
    encouraging an act that falls under any of the above items (including the
    case where the act is being performed by another person).
</p>
<p align="left">
    The Terms of Use are subject to change without notice. When you use or
    browse The Service after any changes made in the Terms of Use, you agree to
    abide by the changed Terms of Use.
</p>
<p align="left">
    <strong>[ 1. Use of The Service ]</strong>
    <strong></strong>
</p>
<p align="left">
    In order to use The Service, you will need to access the Web. The J.LEAGUE
    is not involved in the preparation of, and is not responsible for, the
    method of access to the Web.
</p>
<p align="left">
    <strong>[ 2. User Registration ]</strong>
    <strong></strong>
</p>
<p align="left">
    In order to use The Service, you must fill out the User Registration Form
    and provide true and accurate data about yourself.
</p>
<p align="left">
    The J.LEAGUE reserves the right to delete the ID of any user who violates
    any of the above, or who, in the opinion of the J.LEAGUE, does not provide
    true and accurate data, and to prohibit future use of the service.
</p>
<p align="left">
    <strong>[ 3. ID and password management ]</strong>
    <strong></strong>
</p>
<p align="left">
    You are responsible to manage your IDs and passwords, and any actions taken
    using IDs and passwords shall be deemed the responsibility of the user who
    holds the ID.
</p>
<p align="left">
    In the event that your ID is used without your permission, or your ID and
    password have been leaked to a third party, please immediately reissue your
    password or contact the J.LEAGUE.
</p>
<p align="left">
    <strong>[ 4. Expiry date ]</strong>
    <strong></strong>
</p>
<p align="left">
    You may use your ID and password until you unregister your account
    information from The Service.
</p>
<p align="left">
    However, J.LEAGUE reserves the right to suspend the use of The Service, if
    it seems the service is not used with your ID for an extended period of
    time.
</p>
<p align="left">
    <strong>[ 5. Changes of application details ]</strong>
    <strong></strong>
</p>
<p align="left">
    If there is any change in the registered information, you shall change your
    information without delay in accordance with the usage method.
</p>
<p align="left">
    <strong>[ 6. Disclaimer ]</strong>
    <strong></strong>
</p>
<p align="left">
    The J.LEAGUE takes the utmost care in managing contents of The Service.
    However, we do not guarantee the accuracy, validity, or safety of such
    information, and we do not hold any responsibility for any damage caused by
    the use of The Service or information from The Service.
</p>
<p align="left">
    In addition, any unauthorized use or reproduction of the contents of The
    Service is strictly prohibited.
</p>
<p align="left">
    <strong>[ 7. Handling of Personal Information ]</strong>
    <strong></strong>
</p>
<p align="left">
    Personal information registered on The Service will be used for the purpose
    of providing systematic or business services on The Service under
    appropriate management in accordance with the J.LEAGUE's Privacy Policy.
</p>
<p align="left">
    Personal data will not be disclosed to any third party for any other
    purpose except with the consent of the registrant.
</p>
<p align="left">
    In addition, the J.LEAGUE may use data in a form that does not allow
    individuals to be identified.
</p>
<p align="left">
    <strong>[ 8. Copyright ]</strong>
    <strong></strong>
</p>
<p align="left">
    The copyright of the contents on The Service, including but not limited to
    text, images and video, belongs to the J.LEAGUE and its affiliates. Users
    of The Service are not allowed to reproduce the contents such as documents,
    images, videos, etc. on The Service regardless of commercial or
    non-commercial purposes, except with the consent and permission of each
    copyright holder.
</p>
<p align="left">
    The contents on The Service are protected by the Copyright Act. Please note
    that any act of copyright infringement by users will be punished by
    copyright law.
</p>
<p align="left">
    <strong>[ 9. Link to The Service ]</strong>
    <strong></strong>
</p>
<p align="left">
    If you wish to link to The Service, please be sure to contact the J.LEAGUE.
    Please be aware that we may not allow to link to this website due to the
    contents of The Service.
</p>
<p align="left">
    <strong>[ 10. Management of The Service ]</strong>
    <strong></strong>
</p>
<p align="left">
    The J.LEAGUE reserves the right to change or delete information on The
    Service, and to suspend or discontinue operation of The Service at any time
    without notice. The Service may be temporarily suspended without prior
    notice to the users in the event that any of the following events occur.
</p>
<p align="left">
    - When a periodic or an urgent maintenance of The Service is performed .
</p>
<p align="left">
    - In the event that The Service is unable is unavailable due to fire, power
    outages, etc.
</p>
<p align="left">
    - In the event that The Service is unavailable due to a natural disaster
    such as an earthquake, eruption, flood, and tsunami.
</p>
<p align="left">
    - In the event that The Service is unavailable due to war, disturbance,
    riot, commotion, labor dispute, etc.
</p>
<p align="left">
    - If the J.LEAGUE judges that there is a security problem or that the
    system is overloaded.
</p>
<p>
    - In the event that the J.LEAGUE deems it necessary to temporarily suspend
    The Service for any other operational or technical reasons.
</p>
<p align="left">
    In no event shall the J.LEAGUE be liable for any delay or interruption in
    the provision of The Service due to any of the above items or for any other
    reason whatsoever, and in no event shall the J.LEAGUE be liable for any
    damage suffered by the users or any other person as a result of such delay
    or interruption.
</p>
<p align="left">
    <strong>[ 11.</strong>
    <strong>Governing Law and Jurisdiction ]</strong>
    <strong></strong>
</p>
<p align="left">
    These Terms of Use shall be governed by and construed in accordance with
    the laws of Japan.
</p>
<p align="left">
    Any dispute between a user and the J.LEAGUE in relation to The Service
    shall be settled through consultation between the parties in good faith.
    The Tokyo District Court shall be the exclusive jurisdictional court of the
    first instance for any dispute that cannot be resolved through
    consultation.
</p>
<hr />

      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col
        class="text-center"
        md="3"
        sm="6"
      >
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        md="3"
        sm="6"
      >
        <mp-button wide @click="goAccept" >{{$t("message.account.termsOfUse.button.accept")}}</mp-button>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
// import i18n from '@/message'
import MpButton from '@/components/item/MpButton.vue'

export default {
  name: 'termsOfUse',
  components: {
    MpButton
  },
  data: () => ({
  }),
  computed: {},
  methods: {
    goAccept () {
      window.close()
    }
  },
  created: function () {
  }
}
</script>

<style scoped>
.v-messages {
  min-height: 0px !important;
}
</style>
